export default __webpack_public_path__ + "static/media/renaissance.b289e36c.jpeg";